<template>
  <v-container>
     
     <v-row>
          <v-select dense v-model="resolution" item-text="name" item-value="id" :items="resolutions" label="Resolutions"></v-select>
     </v-row>
     <v-row>
          <v-select dense v-model="aggregate" item-text="name" item-value="id" :items="aggregations" label="Aggregations"></v-select>
     </v-row>
     <!-- <v-row>
          <v-select dense v-model="datatype" item-text="name" item-value="id" :items="datatypes" label="Data Type"></v-select>
     </v-row>
     <v-row>
          <v-select dense v-model="overlay" item-text="name" item-value="id" :items="overlays" label="Overlay"></v-select>
     </v-row> -->
     <v-row>
          <v-checkbox dense v-model="adjust_for_rooms" label="Adjust for rooms"></v-checkbox>
     </v-row>

     <!-- <v-row>
          <v-checkbox dense v-model="use_names_in_header" label="Use names in header"></v-checkbox>
     </v-row> -->

     <!-- <v-row>
          <v-checkbox dense v-model="compression" label="Compression"></v-checkbox>
     </v-row> -->

  </v-container>

</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';


@Component({
  components: {},
})
export default class DisplayOptions extends Vue {

  public resolutions: object[] = [ {id: 'all', name: 'All'},
                                   {id: 'minute', name: '1 Minute'},
                                   {id: 'fiveminute', name: '5 Minute'},
                                   {id: 'twentyminute', name: '20 Minute'},
                                   {id: 'thirtyminute', name: '30 Minute'},
                                   {id: 'hour', name: '1 Hour'},
                                   {id: 'day', name: '1 Day'},
                                   {id: 'week', name: '1 Week'},
                                   {id: 'month', name: 'Monthly'},
                                   // {id: 10, name: 'Monthly (Linearly Interpolated)'},
                                   // {id: 11, name: 'Monthly Rolling Average'},
                                   // {id: 14, name: 'Monthly Rolling Sum'},
                                   {id: 'year', name: 'Yearly'},
                                   ];

  private resolution: string = this.resolutions[5]['id'];

  private aggregations: object[] = [{id: 'avg', name: 'Avg'},
                                   {id: 'sum', name: 'Sum'},
                                   {id: 'max', name: 'Max'},
                                   {id: 'min', name: 'Min'},
                                   {id: 'diff', name: 'Incremental'},
                                   ];

  private aggregate: string = this.aggregations[0]['id'];

  private datatype: number = -1;
  private datatypes: object[] = [{id: 0, name: 'Original'},
                                  {id: 1, name: 'Cleaned'},
                                   {id: 2, name: 'Both'},
                                   ];

  private overlay: number = -1;
  private overlays: object[] = [{id: 0, name: 'None'},
                                   {id: 1, name: 'Yearly'},
                                   {id: 2, name: 'Monthly'},
                                   {id: 3, name: 'Weekly'},
                                   ];

  private incremental: boolean = false;
  private adjust_for_rooms: boolean = false;
  // private use_names_in_header: boolean = false;
  private compression: boolean = false;

  @Watch('resolution')
  protected onResolutionChanged(newValue: string, oldValue: string): any {
    this.$emit('setResolution', newValue);
  }

  @Watch('aggregate')
  protected onAggregateChanged(newValue: string, oldValue: string): any {
    this.$emit('setAggregate', newValue);
  }

  @Watch('datatype')
  protected onDataTypeChanged(newValue: number, oldValue: number): any {
    // this.$store.commit('setDataType', newValue);
  }

  @Watch('adjust_for_rooms')
  protected onAdjustForRoomsChanged(newValue: boolean, oldValue: boolean): any {
    this.$emit('setAdjustForRooms', newValue);
  }

  // @Watch('use_names_in_header')
  // protected onAdjustForUseNamesInHeaderChanged(newValue: boolean, oldValue: boolean): any {
  //   this.$store.commit('setUseNameInHeader', newValue);
  // }

  private created() {

    const self = this;

    // this.$store.dispatch('setResolution', this.resolution.id);
    this.$emit('setResolution', this.resolution);
    this.$emit('setAggregate', this.aggregate);
    this.$emit('setAdjustForRooms', this.adjust_for_rooms);

    //this.$store.dispatch('setAggregate', this.aggregate.id);

    // this.$store.dispatch('setUseNameInHeader', false);

    // this.$store.watch(
    //   (state) => {
    //     return this.$store.state.resolution; // could also put a Getter here
    //   },
    //   (newValue, oldValue) => {
    //     // something changed do something
    //     self.$store.dispatch('setResolution', newValue);
    //     self.resolution = newValue;
    //   },
    //     // Optional Deep if you need it
    //     {
    //       deep: true,
    //     },
    // );

    // this.$store.watch(
    //   (state) => {
    //     return this.$store.state.aggregate; // could also put a Getter here
    //   },
    //   (newValue, oldValue) => {
    //     // something changed do something
    //     self.$store.dispatch('setAggregate', newValue);
    //     self.aggregate = newValue;
    //   },
    //     // Optional Deep if you need it
    //     {
    //       deep: true,
    //     },
    // );

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
